import { useGetDocumentSource } from "../../../sources/api/useGetDocumentSource";
import { CitationIndex } from "../../../sources/models/Citation";
import { useEffect, useMemo } from "react";
import { parseIntOrUndefined } from "../../../../shared/utils/Number";
import CenterLoader from "../../../../shared/components/loader/CenterLoader";
import SidebarUserDocument from "./SidebarUserContent";

interface SidebarUserContentCitationProps {
  citation: CitationIndex;
  chatId: string;
  setWiderSidebar: (isWider: boolean) => void;
}

export function SidebarUserContentCitation({
  citation,
  chatId,
  setWiderSidebar,
}: SidebarUserContentCitationProps) {
  const {
    source,
    getDocumentSource,
    isLoading: isLoadingContent,
  } = useGetDocumentSource();

  const memoizedCitation = useMemo(() => citation, [citation]);

  useEffect(() => {
    getDocumentSource(
      memoizedCitation.documentId,
      parseIntOrUndefined(memoizedCitation.chunkId),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memoizedCitation, chatId]);

  return (
    <>
      {isLoadingContent && <CenterLoader />}
      <div className="h-full overflow-hidden">
        {source && (
          <SidebarUserDocument
            documentId={source.id}
            chunkText={source.content}
            pageNumber={source.pageNumber}
            boundingBox={source.boundingBox}
            setWiderSidebar={setWiderSidebar}
          />
        )}
      </div>
    </>
  );
}
